import React, { useContext, useState } from 'react';

import { toast } from 'react-toastify';

import {
  TAmortizationResponse,
  TBudgetResponse,
  TBuyerQualResponse,
  TBuyersChoiceResponse,
  TBuyOrRentResponse,
  TBuyWaitResponse,
  TClosingCostResponse,
  THecmResponse,
  TInvestmentResponse,
  TSellerNetResponse,
  TVacationResponse,
  TConsumerDebtResponse,
  TPaymentSubsidyResponse, TVacationResponseV2, TBuyOrRentResponseV2, TBuyerQualChoiceResponseV2,
} from '../../../types/api';
import { ButtonWithSpinner, UiSettingsProviderContext } from '../../atoms';

type Props = {
  dats:
    | TBuyerQualResponse
    | TAmortizationResponse
    | TBudgetResponse
    | TBuyersChoiceResponse
    | TBuyerQualChoiceResponseV2
    | TBuyOrRentResponse
    | TBuyOrRentResponseV2
    | TBuyWaitResponse
    | TClosingCostResponse
    | TInvestmentResponse
    | THecmResponse
    | TSellerNetResponse
    | TVacationResponse
    | TConsumerDebtResponse
    | TPaymentSubsidyResponse
    | TVacationResponseV2
};

export const ButtonSendPdf = ({ dats }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { currentSettings } = useContext(UiSettingsProviderContext);

  const onSendMail = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(currentSettings.apiUrls.sendPdf, {
        method: 'POST',
        body: JSON.stringify(dats),
      });
      const resData = await res.json();
      toast.success(resData);
      setIsLoading(false);
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        toast.error('Something went wrong!');
      }
      setIsLoading(false);
    }
  };

  return (
    <div className="mx-2">
      <ButtonWithSpinner loadingIndicator="Sending..." loading={isLoading} onClick={onSendMail} variant="outline-primary" type="button">
        Send to email
      </ButtonWithSpinner>
    </div>
  );
};
